/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './card-options.stache';
import dayjs from 'dayjs';
import stacheHelpers from 'helpers/client';

const HIDDEN_WHEN_TYPES = ['trendingCard'];

Component.extend({
    tag: 'card-options',
    template: template,
    viewModel: {
        isVisible: function () {
            return HIDDEN_WHEN_TYPES.indexOf(this.attr('type')) === -1;

        }
    },
    helpers: {
        cardType: function (options) {
            let type = options.context.attr('type');

            if(!type){
                console.error('Card type is not defined.');
                return;
            }

            let formattedType = type.replace(/Card/gi, '');

            if (formattedType == 'social') {
                return options.context.attr('network');
            } else {
                return formattedType;
            }
        },
        timeago: function (options) {
            let timeStamp = options.context['date'];
            let actionMoment = dayjs(timeStamp);
            let nowMoment = dayjs();
            let result;

            if (!timeStamp) {
                return '';
            }

            if (nowMoment.diff(actionMoment, 'minutes') < 2) {
                return 'Now';
            }

            if (nowMoment.diff(actionMoment, 'minutes') >= 2 && nowMoment.diff(actionMoment, 'hours') < 1) {
                result = nowMoment.diff(actionMoment, 'minutes');
                return result + 'm ago';
            }

            if (nowMoment.diff(actionMoment, 'hours') >= 1 && nowMoment.diff(actionMoment, 'hours') < 24) {
                result = nowMoment.diff(actionMoment, 'hours');
                return result + 'h ago';
            }

            if (nowMoment.diff(actionMoment, 'days') >= 1 && nowMoment.diff(actionMoment, 'days') < 7) {
                result = nowMoment.diff(actionMoment, 'days');
                return result + 'd ago';
            }

            if (nowMoment.diff(actionMoment, 'days') >= 7) {
                result = nowMoment.diff(actionMoment, 'weeks');
                return result + 'w ago';
            }

        }
    }
});
